import { render, staticRenderFns } from "./NotificationConfig.vue?vue&type=template&id=639109f5&"
import script from "./NotificationConfig.vue?vue&type=script&lang=ts&"
export * from "./NotificationConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports